<template>
<div>
   
<table class="table table-sm table-bordered  table-hover">
    <thead class="detail_">
    <tr :style="{backgroundColor : '#FFFF99',color: 'blue' ,fontSize:  '15px',fontWeight:'bold' }" >
        <th 
        :style="{backgroundColor : index > 2 ? '#567ab0':'white',color: index > 2 ? 'white':'blue' ,fontSize:  '15px',fontWeight:'bold' }"
         v-for="(col,index) in cols" :key="index">
            {{col}}
        </th>
    </tr>
    </thead>
    <tbody>
    <tr :style="{color: setColor(item.Tipo) ,fontSize:  '14px' }"  v-for="(item, index) in rows" :key="index">
    <td class="text-nowrap" v-for="(col,index) in cols" :key="index">
        {{item[col]}}
    </td>
    </tr>
    </tbody>
</table>

</div> 
</template>

<script>


export default {
   props: ['cols','rows'],
   components: {
  
   
  },
  data () {
    return { 

        color : ['#006600','#990000','#660099','#dc143c'],     
        
       
    }
  },
  computed: 
  {   
    
  },


  created()
  { 
    
  
  },
      
  mounted()
  {},
  methods: 
  {
      setColor(type)
      {
          var color = ''
          if(type == 'Immesso')
          {
              color = this.color[0]
          }
          if(type == 'Reso')
          {
              color = this.color[3]
          }
          if(type == 'Venduto')
          {
              color = this.color[1]
          }  
          if(type == 'Stock')
          {
              color = this.color[2]
          }
          return color
      }
  }
  
}
</script>

<style scoped>
.detail {
    background    : yellow;
    font-family  : 'Roboto Condensed';
    font-size     : 20px;
}
.table th:first-child
{
  border-radius : 0 0 0 10px;
}
.table th:last-child
{
  border-radius : 0 10px 0 0;  
}
</style>